export class BaseModel {
	// Edit
	_isEditMode: boolean = false;
	// Log
	_userId: string = '0'; // Admin
	_createdDate: string;
	_updatedDate: string;
}
